import { IOffer } from "@/i/offer";

export const factoryProducts = (products, noStatuses) => {
  let prod: IOffer[] = [];
  const formatterPrice = price => {
    if (price) {
      let formattedPrice: any = (+price).toFixed(2).split(".");
      if (+formattedPrice[0] > 10000) {
        formattedPrice[0] = formattedPrice[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          "."
        );
      }
      return (formattedPrice = formattedPrice.join(","));
    }
  };

  products.forEach((element, i) => {
    prod.push({
      new: noStatuses ? false : i === 0,
      img: element.image_url_large
        ? element.image_url_large
        : element.image_url_small,
      name: element.title,
      currency: element.currency,
      description: element.description,
      price: formatterPrice(element.regular_price),
      old_price: formatterPrice(element.old_price),
      store_url: element.store_url,
      merchant: element.url,
      date: element.updatedAt,
      recommended: noStatuses ? false : i === 6,
      demand: noStatuses ? false : i === 4,
      trending: noStatuses ? false : i === 18
    });
  });

  return prod;
};
